export default "__VITE_ASSET__BnKcZHIW__"